module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/youtube-660d9c9c0c41e823b9ece0feb93707b5.svg&quot;;"